import Vue from 'vue'
import Router from 'vue-router'

// Импортируем в роутер все используемые компоненты
const ErrorPage404 = () => import(/* webpackChunkName: "ErrorPage404" */ "@/views/ErrorPage404.vue")
const LoginPage = () => import(/* webpackChunkName: "LoginPage" */ "@/views/LoginPage.vue")
const ForgotPage = () => import(/* webpackChunkName: "ForgotPage" */ "@/views/ForgotPage.vue")
const ResetPage = () => import(/* webpackChunkName: "ResetPage" */ "@/views/ResetPage.vue")
const CheckSign = () => import(/* webpackChunkName: "CheckSign" */ "@/views/CheckSign.vue")
const CostCalc = () => import(/* webpackChunkName: "CostCalc" */ "@/views/CostCalc.vue")
const PrivacyPolicy = () => import(/* webpackChunkName: "PrivacyPolicy" */ "@/views/PrivacyPolicy.vue")
const SignUp = () => import(/* webpackChunkName: "SignUp" */ "@/views/SignUp.vue")
const ContactsPage = () => import(/* webpackChunkName: "ContactsPage" */ "@/views/ContactsPage.vue")
const InfoPage = () => import(/* webpackChunkName: "InfoPage" */ "@/views/InfoPage.vue")
const InfoItem = () => import(/* webpackChunkName: "InfoItem" */ "@/views/InfoItem.vue")
const ApplicationView = () => import(/* webpackChunkName: "ApplicationView" */ "@/views/ApplicationView.vue")
const ApplicationCard = () => import(/* webpackChunkName: "ApplicationCard" */ "@/views/ApplicationCard.vue")
const ApplicationCreate = () => import(/* webpackChunkName: "ApplicationCreate" */ "@/views/ApplicationCreate.vue")
const UserProfile = () => import(/* webpackChunkName: "UserProfile" */ "@/views/UserProfile.vue")
const UserDocuments = () => import(/* webpackChunkName: "UserDocuments" */ "@/views/UserDocuments.vue")
const UserNotices = () => import(/* webpackChunkName: "UserNotices" */ "@/views/UserNotices.vue")
const AdminApplications = () => import(/* webpackChunkName: "AdminApplications" */ "@/views/AdminApplications.vue")
const AdminUsers = () => import(/* webpackChunkName: "AdminUsers" */ "@/views/AdminUsers.vue")

Vue.use(Router)

// Настройки путей роутера
let router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			// путь (URL)
			path: '/',
			// Имя
			name: 'home',
			// Используемый компонент
			component: ApplicationView,
			meta: {
				// Шаблон вывода
				layout: "inside-layout",
				// Требуется ли авторизация для просмотра страницы
				requiresAuth: true,
				// Заголовок в браузере
				title: "Мои заявки"
			}
		},
		{
			path: '/login',
			name: 'login',
			component: LoginPage,
			meta: {
				layout: "inside-layout",
				title: "Вход"
			}
		},
		{
			path: '/forgot',
			name: 'forgot',
			component: ForgotPage,
			meta: {
				layout: "inside-layout",
				title: "Восстановление пароля"
			}
		},
		{
			path: '/reset/:id',
			name: 'reset',
			component: ResetPage,
			props: true,
			meta: {
				layout: "inside-layout",				
				title: "Придумайте новый пароль"
			}
		},
		{
			path: '/check',
			name: 'check',
			component: CheckSign,
			meta: {
				layout: "inside-layout",
				title: "Проверка товарного знака"
			}
		},
		{
			path: '/calc',
			name: 'calc',
			component: CostCalc,
			meta: {
				layout: "inside-layout",
				title: "Калькулятор стоимости регистрации"
			}
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: PrivacyPolicy,
			meta: {
				layout: "inside-layout",
				title: "Политика обработки персональных данных"
			}
		},
		{
			path: '/signup',
			name: 'signup',
			component: SignUp,
			meta: {
				layout: "inside-layout",
				title: "Калькулятор стоимости регистрации"
			}
		},
		{
			path: '/application/view',
			name: 'application-view',
			component: ApplicationView,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Мои заявки"
			}
		},
		{
			path: '/application/card/:application_id',
			name: 'application-card',
			component: ApplicationCard,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Карточка заявки"
			}
		},
		{
			path: '/application/create',
			name: 'application-create',
			component: ApplicationCreate,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Создание заявки"
			}
		},		
		{
			path: '/user/documents',
			name: 'user-documents',
			component: UserDocuments,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Документы по заказам"
			}
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: ContactsPage,			
			meta: {
				layout: "inside-layout",				
				title: "Контакты"
			}
		},
		{
			path: '/info',
			name: 'info',
			component: InfoPage,			
			meta: {
				layout: "inside-layout",				
				title: "Документация"
			}
		},
		{
			path: '/info/:item_id',
			name: 'info-item',
			component: InfoItem,
			props: true,
			meta: {
				layout: "inside-layout",				
				title: "Документация"
			}
		},
		{
			path: '/user/notices',
			name: 'user-notices',
			component: UserNotices,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Уведомления"
			}
		},
		{
			path: '/admin/applications',
			name: 'admin-applications',
			component: AdminApplications,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Админ - Заявки"
			}
		},
		{
			path: '/admin/users',
			name: 'admin-users',
			component: AdminUsers,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Админ - Пользователи"
			}
		},
		{
			path: '/user/profile',
			name: 'user-profile',
			component: UserProfile,			
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Мой профиль"
			}
		},
		{
			path: '/user/:id',
			name: 'user-view-profile',
			component: UserProfile,
			props: true,
			meta: {
				layout: "inside-layout",
				requiresAuth: true,
				title: "Профиль пользователя"
			}
		},
		{
			path: "*",
			component: ErrorPage404,
			meta: {
				layout: "inside-layout",
				title: "404: Страница не найдена"				
			}
		}
	]
})

// Проставляем заголовок в браузере в зависимости от текущего пути
router.beforeEach((to, from, next) => {
	const { title } = to.meta
	const brand = localStorage.getItem('app_title') || ""
	document.title = `${title ? title + " — " : ""}${brand}`
	const tokenStamp = localStorage.getItem('app_token')	
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (tokenStamp) {
			next()
			return
		}
		next('/login')
	} else {
		next()
	}
})

export default router